import { humanize } from '@app/utils/formatting'
import * as React from 'react'
import { Col, FormGroup, Input, Label } from 'reactstrap'

interface IBidirectionalSortComponents {
  md?: number
  xl?: number
  orderBy: string
  changeOrdering: any
}

export default class BidirectionalSort extends React.PureComponent<IBidirectionalSortComponents> {
  public render() {
    return (
      <Col md={this.props.md} xl={this.props.xl}>
        <FormGroup>
          <Label>Direction</Label>
          <Input
            type='select'
            bsSize='sm'
            value={this.props.orderBy}
            onChange={this.props.changeOrdering}
          >
            {['Ascending', 'Descending'].map((c, i) => (
              <option key={`sort-${i}`} value={c}>
                {humanize(c)}
              </option>
            ))}
          </Input>
        </FormGroup>
      </Col>
    )
  }
}
